export default {
  reviewCompleteHeader: 'Revisar y Completar',
  participants: 'Participantes',
  enterParticipantInfoText:
    'Por favor, introduce la información de los participantes en la experiencia. Si queda espacio, agrega más participantes a la experiencia.',
  purchaser: 'Comprador',
  firstName: 'Nombre',
  lastName: 'Apellido',
  email: 'E-mail',
  optionalEmail: 'E-mail: (opcional)',
  duplicatePurchaserText: 'Igual que el Comprador',
  phone: 'Teléfono: (opcional)',
  addParticipant: 'Añadir {{tierLabel}}',
  participant: 'Participante',
  removeParticipant: 'Eliminar',
  experienceCheckoutCompleted: 'Pago de la experiencia completado',
  experienceCartCheckout: 'Pago del carrito de experiencia',
  experienceLimitReached:
    'Lo sentimos, esta experiencia ha alcanzado su número máximo de participantes',
  payment: 'Pago',
  duration: 'Duración',
  discountCode: 'Código de Descuento',
  removeCode: 'Eliminar Código',
  invalidCodeValidation: 'Código de Cupón No Válido',
  networkErrorDiscountCode: 'Algo salió mal por nuestra parte',
  onlyOneCouponCodeAllowed: 'Solo se permite un código de cupón',
  creditCodeHasAlreadyBeenApplied: 'El código de crédito ya ha sido aplicado',
  discount: 'Descuento',
  promo: 'Promo',
  promoCode: 'Promo code',
  apply: 'Aplicar',
  total: 'Total',
  subTotal: 'Tsubtotal',
  includes: 'incluye',
  and: 'y',
  addHostNotes: 'Añade comentarios para tu anfitrión ',
  brandAggreementText:
    'Acepto o certifico de otro modo, que estoy autorizado, en nombre de este participante, a aceptar los términos y condiciones del',
  termsAggreementValidation: 'Por favor, acepta los términos',
  firstNameValidation: 'Se requiere el Nombre',
  lastNameValidation: 'Se requiere el Apellido',
  emailValidation: {
    emailRequiredText: 'Se requiere una Dirección de E-mail',
    'Invalid Email Address': 'Dirección de E-mail Inválida',
    not_specified: 'Dirección de E-mail Incorrecta',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Número de Teléfono No Válido',
    not_specified: 'Inválida',
  },
  participantFirstNameValidation: 'Se requiere el Nombre del Participante',
  participantLastNameValidation: 'El Apellido del Participante es obligatorio',
  complete: 'Completar',
  '404Message': 'Página no encontrada',
  waiting: 'Esperando...',
  complimentary: 'Gratis',
  confirmationHeader: '¡Tu experiencia ha sido reservada!',
  confirmationText:
    'Se envió un e-mail de confirmación a {{email}} con detalles adicionales',
  viewAll: 'Ver todas las Experiencias',
  paymentMethod: 'Método de Pago',
  creditCard: 'Tarjeta de Crédito',
  roomCharge: 'Cargo por Habitación',
  memberCharge: 'Cargo por Miembro',
  roomNumber: 'Número de Habitación',
  memberNumber: 'Número de Miembro',
  chargeValidation: 'Se requiere el Número de Habitación y el Apellido',
  memberNumberValidation: 'Se requiere Número de Miembro y Apellido',
  invalidRoomNumber: 'El número de habitación no es válido',
  invalidMemberNumber: 'El número de miembro no es válido',
  cardNumberIncomplete: 'Número de Tarjeta Incompleto',
  lastNameValidationError: 'Se requiere el Apellido',
  isReqd: 'es obligatorio',
  private: 'Privado',
  browseAllExperieces: 'Explorar todas las Experiencias',
  payWithCreditCard: 'Pagar con Tarjeta de Crédito',
  payWithRoomCharge: 'Pagar con Cargo por Habitación',
  payWithMemberCharge: 'Pagar con Cargo por Miembro',
  payWith: 'Pagar con',
  bookBulkErrorByCard:
    'Hubo un problema al confirmar su reserva. Su tarjeta no fue cargada.',
  bookBulkErrorByRoomCharge: 'Apellido y número de habitación no válidos.',
  bookBulkErrorByMemberCharge: 'Apellido y número de miembro no válidos.',
  reviewCancellation: 'Revisar Cancelación',
  selectAReservationToCancel: 'Selecciona una reserva para cancelar',
  confirmCancellation: 'Confirmar cancelación',
  cancellable: 'Cancelable',
  cancelled: 'Cancelado',
  deadlinePassed: 'Plazo de cancelación pasado',
  noCancellations: 'No se pueden realizar cancelaciones',
  reviewReschedule: 'Tu reserva',
  selectAReservationToReschedule: 'Selecciona una reserva para reprogramar',
  confirmReservation: 'Confirmar reserva',
  confirm: 'Confirmar',
  selectADateAndTime: 'Selecciona una fecha y hora',
  noOtherSessionsAvailableForThisExperience:
    'No hay otras sesiones disponibles para esta experiencia.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Esta reserva ya no se puede reprogramar. Por favor, envía un correo a {{brandEmail}}',
  thisReservationCannotBeRescheduled: 'Esta reserva no se puede reprogramar',
  noTimesAvailable: 'No hay horarios disponibles',
  noBookingsAvailable: 'No hay reservas disponibles',
  youPaid: 'Has pagado',
  refund: 'Reembolso',
  yourRefund: 'Tu reembolso',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Tu reembolso será procesado al método de pago original.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Esta reserva ya no se puede cancelar. Por favor, envía un correo electrónico a {{brandEmail}}',
  reservationCancelled: 'Reserva cancelada',
  thisReservationCannotBeCancelled: 'Esta reserva no se puede cancelar',
  thisReservationHasAlreadyBeenCancelled: 'Esta reserva ya ha sido cancelada',
  theHotel: 'el Hotel',
  cancelling: 'Cancelando',
  somethingWentWrong: 'Algo salió mal',
  previouslyRefunded: 'Reembolsado previamente',
  remainingBalance: 'Saldo restante',
  phoneNumber: 'Número de teléfono',
  requestToBookConfirmationText:
    'Un correo electrónico de confirmación fue enviado a {{email}}',
  reservationRescheduled: 'Reserva reprogramada',
  yourReservationWasRescheduledTo: 'Tu reserva fue reprogramada para',
  viewExperiences: 'Ver experiencias',
  joinBook: 'Unirse y reservar',
  signInBook: 'Iniciar sesión y reservar',
  signAndJoin: 'Iniciar sesión o unirse para reservar',
  signAndJoinDescription:
    'Las experiencias World of Hyatt son exclusivas para los miembros World of Hyatt. Inicie sesión o se una a la reserva y gane puntos. ¿Prefiere no unirse? Aún puede reservar experiencias no exclusivas eliminando la experiencia World of Hyatt de su carrito.',
  promoOrFind: 'Código promocional o código de crédito FIND',
  hyattTermsAndConditions: 'Términos y condiciones',
  hyattTermsAndConditionsAgreement:
    'Al confirmar esta reserva, acepto la política de cancelación. También he leído y reconozco el uso de mi información personal de acuerdo con las',
  hyattTermsAndConditionsLink: 'Políticas de privacidad de Hyatt',
  hyattWaiverText:
    'Al comprar esta experiencia, acepto, entiendo y reconozco, tanto en mi propio nombre como en nombre de cualquier persona que participe en la experiencia adquirida por mí (si corresponde), lo siguiente',
  hyattWaiverLink: 'renuncia general',
  priceDisclaimer: 'Incluye cargos antes de impuestos',
  curatedRecommendations: 'Recomendaciones personalizadas',
  moreExperiencesYouMightLike: 'Otras experiencias que podrías gustar',
  similarExperiencesAvailableToBookDirectly:
    'Experiencias similares disponibles para reservar directamente',
  experiencesAvailableAroundYourBookingDate:
    'Experiencias disponibles cerca de tu fecha de reserva',
  confirmationEmailSent:
    'Hemos enviado tu confirmación a {{email}} con más detalles.',
  youreBooked: 'Estás reservado',
  purchaserInformation: 'Información del comprador',
  requiredFieldIndicator: '* indica un campo obligatorio',
  resourceSelectionTitle: 'Elige tus opciones',
  resourceSelectionDescription:
    'Elige una opción para cada artículo de tu reserva.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Selecciona {{attributeName}}',
  resourceValueSoldOut: '{{label}} (agotado)',
  resourceValueUnavailableWith: '{{label}} (no disponible con {{picks}})',
  resourceOptionsUnavailable:
    'No pudimos cargar las opciones para este horario. Inténtalo de nuevo.',
  resourceOptionsRetry: 'Intentar de nuevo',
  changeResourceSelections: 'Cambiar tus elecciones',
};
